import { FC, SVGProps } from 'react';

const ArrowExpandIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M9.33325 11.6666L13.9999 16.3333L18.6666 11.6666"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowExpandIcon;
